import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import MarginField from "./MarginField";
import { carrierOptions, serviceOptions } from "./postalServiceOptions";

const initial = {
    platform: "",
    clientName: "",
    psCode: "",
    psTypeCode: "",
    marginPrice: 0,
    insPercent: 0,
};

const CreateDialog = ({ visible, onHide, onSubmit, loading, orgs = [], postalServices = [] }) => {
    const [data, setData] = React.useState(initial);
    const [submitted, setSubmitted] = React.useState(false);

    React.useEffect(() => {
        if (visible) {
            setData(initial);
            setSubmitted(false);
        }
    }, [visible]);

    const update = (k, v) => setData(d => ({ ...d, [k]: v }));

    const carriers = React.useMemo(() => carrierOptions(postalServices), [postalServices]);
    const services = React.useMemo(
        () => serviceOptions(postalServices, data.psCode),
        [postalServices, data.psCode]
    );

    const isValid =
        !!data.platform &&
        !!data.psCode &&
        (data.marginPrice === null || data.marginPrice >= 0) &&
        data.insPercent >= 0;

    const handleSave = () => {
        setSubmitted(true);
        if (!isValid) return;
        onSubmit({
            ...data,
            clientName: data.clientName.trim() || null,
            psTypeCode: data.psTypeCode || null,
        });
    };

    const footer = (
        <div>
            <Button label="Отмена" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button label="Сохранить" icon="pi pi-check" loading={loading} onClick={handleSave} />
        </div>
    );

    return (
        <Dialog header="Создать наценку" visible={visible} style={{ width: "500px" }}
                modal onHide={onHide} footer={footer}>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12">
                    <label>Платформа *</label>
                    <Dropdown value={data.platform} options={orgs}
                              optionLabel="name" optionValue="name"
                              onChange={e => update("platform", e.value)}
                              placeholder="Выберите"
                              className={submitted && !data.platform ? "p-invalid" : ""} />
                </div>
                <div className="p-field p-col-12">
                    <label>Клиент</label>
                    <InputText value={data.clientName} onChange={e => update("clientName", e.target.value)} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <label>Перевозчик *</label>
                    {/* услуга принадлежит перевозчику — при смене перевозчика сбрасываем */}
                    <Dropdown value={data.psCode} options={carriers}
                              onChange={e => setData(d => ({ ...d, psCode: e.value, psTypeCode: "" }))}
                              placeholder="Выберите"
                              className={submitted && !data.psCode ? "p-invalid" : ""} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <label>Услуга перевозчика</label>
                    <Dropdown value={data.psTypeCode} options={services}
                              onChange={e => update("psTypeCode", e.value)}
                              disabled={!data.psCode}
                              showClear
                              placeholder={data.psCode ? "Выберите" : "Сначала перевозчик"} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <MarginField value={data.marginPrice} onChange={v => update("marginPrice", v)} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <label>Страховка</label>
                    <InputNumber value={data.insPercent} mode="decimal" minFractionDigits={2} maxFractionDigits={3} min={0}
                                 onValueChange={e => update("insPercent", e.value ?? 0)} />
                </div>
            </div>
        </Dialog>
    );
};

export default CreateDialog;
